import { defineKey as T } from 'ha/i18n';
import { PaymentRequestStatus } from 'ha/services/osiris/paymentRequests';

export const STATE_NAME = 'payoutsPaymentRequests';
export const PAYMENT_REQUESTS_PER_PAGE = 10;
export const STATUS_LABELS: { [K in PaymentRequestStatus]: string } = {
  cancelled: T('Cancelled'),
  paid: T('Paid'),
  unpaid: T('Unpaid'),
  overdue: T('Overdue'),
};

export const alertMessages = {
  pr_cancel_success: T('Payment request has been canceled'),
  pr_cancel_error: T('Payment request could not be canceled'),
};
